<template>
  <div class="emojis-stack">
    <emoji-circle
      v-for="(participantIcon, index) in participantsIcons"
      :key="index"
      :emoji="participantIcon.emoji"
      :color="participantIcon.color"
      class="emoji"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import EmojiCircle from './EmojiCircle.vue';
import { icons, flexDirectionByStackDirection, StackDirection } from './consts';
import { ParticipantCircle } from '../../types/participant';

interface Props {
  stackDirection: StackDirection;
  participantsCircleData?: ParticipantCircle[];
}
const props = defineProps<Props>();

const participantsIcons = computed(() =>
  (props.participantsCircleData && props.participantsCircleData.length > 0 ? props.participantsCircleData : icons[props.stackDirection]));
const isVertical = computed(() => ([StackDirection.UP, StackDirection.DOWN].includes(props.stackDirection)));
const isHorizontal = computed(() => ([StackDirection.LEFT].includes(props.stackDirection)));

</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/riseup-colors';
@import '@riseupil/base-ui/src/scss/spacings';

  .emojis-stack {
    display: flex;
    padding: v-bind("isVertical ? '32px 0 0 0' : '0 32px 0 0'");
    flex-direction: v-bind("flexDirectionByStackDirection[props.stackDirection]");

    .emoji {
      position: relative;
      margin-block-start: v-bind("isVertical ? '-32px' : 'none'");
      margin-inline-start: v-bind("isHorizontal ? '-32px' : 'none'");
      border: 1px solid white;
    }
  }

</style>
